<!-- ======= Header 2 ======= -->
<header class="header fixed-top header-scrolled " data-aos="zoom-in">
    <div class="container d-flex align-items-center py-3 ">

        <!-- Uncomment below if you prefer to use an image logo -->
        <a id="main-logo" routerLink="" class="logo mr-auto"><img src="../assets/img/logo/logo_with_name.svg" alt=""></a>
        <div class="contact-info mr-auto d-none text-white d-lg-block">
            <i class="icofont-email text-white"></i> <a href="mailto: info@dtycoons.com" style="color:white;"> info@doksinternational.com </a>
            <span class="px-3"></span>
            <i class="icofont-phone"></i> +94 11 429 4747 / 4748
        </div>
        <nav class="nav-menu d-none d-lg-block  ">

            <ul>
                <li><a routerLink="">Home</a></li>

            </ul>
        </nav>
        <!-- .nav-menu -->

    </div>

</header>
<!-- End Header -->
